import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c0dac898&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dac898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0dac898')) {
      api.createRecord('c0dac898', component.options)
    } else {
      api.reload('c0dac898', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c0dac898&scoped=true", function () {
      api.rerender('c0dac898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/my_radius/index.vue"
export default component.exports